var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMHat2WHair1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "w-hair1_5_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D0E09B",
    d: "M571.5,152.9c1.7-30.1-8.9-59.9-27.9-83c-101.4-81.7-226.2-85.5-328-15.3c-74,51-132,146-97,195 c0.5,2.6,12.9,12.6,15.3,15.7c26.7,17.6,57.2-8.2,76-24.7c10.9-9.6,26.8-27.9,38.7-36c18.9-13,90.3-15.2,111-12.5l56,2 c0.9,0.7,57.6,2.7,58.5,3.5c20,18,28.5,55.7,29.4,70.6c6.1-16,18.8-29.1,34-39.4c12.6-13,22.2-28.8,27.9-45.8 C568.7,173.2,570.8,163,571.5,152.9z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "hats_w-hair1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m-hat2_1_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E9C29B",
    d: "M505.9,194.9c3.7-4.2,18.2-18,12.1-22.2c-89.7-16.1-182.3-19.4-273.3-7.2c-12,1.6-24,3.4-35.9,5.5 c-6.8,1.3-13.5,2.8-20.2,4.4c-1.5,4.1,4.4,11.2,6.6,13.9c4,5,8.2,10.2,12.9,14.7c5.2,5,11.6,9.3,17.8,9.3 c82.8-19.9,170.8-19,255.3-3.5C492.1,209.2,499.1,202.6,505.9,194.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D3A77C",
    d: "M234.5,166.8c-8.6,1.2-17.2,2.6-25.7,4.1c-6.8,1.3-13.5,2.8-20.2,4.4c-1.5,4.1,4.4,11.2,6.6,13.9 c4,5,8.2,10.2,12.9,14.7c5.2,5,11.6,9.3,17.8,9.3c30-7.2,60.8-11.7,91.8-13.7C287.3,194.7,256.2,186.8,234.5,166.8z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E9C29B",
    d: "M240.3,80.4c-9.1,25.3-15.6,60.4-16.5,88c6.9-1.1,13.9-2.1,20.8-3c79.3-10.6,159.8-9.5,238.5,1.7 c-2.6-32.4-8-64.4-18.5-94.4C405.5,56,308.3,50.2,240.3,80.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D3A77C",
    d: "M240.3,80.4c-7.3,20.4-13,47.2-15.4,71.3c10.7-2.3,21.7-4.3,32.9-6c0.1-24.9,4.1-53.9,9.8-75.1 C258.1,73.3,249,76.5,240.3,80.4z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1A110C",
    d: "M224.9,151.7c-0.6,5.8-0.9,11.4-1.1,16.8c6.9-1.1,13.9-2.1,20.8-3c79.3-10.6,159.8-9.5,238.5,1.7 c-0.4-5.1-0.9-10.2-1.5-15.3C403.8,133.8,306.1,134.1,224.9,151.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#947D70",
    d: "M437.1,143.7c-7.6-1-15.3-1.9-23.1-2.6l0.9,18.9c7.8,0.5,15.6,1.1,23.3,1.8L437.1,143.7z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMHat2WHair1);
export default __webpack_public_path__ + "static/media/m-hat2_w-hair1.a5a3eee2b5c86a3fb6ba7477f00403a9.svg";
export { ForwardRef as ReactComponent };